import { HostingDisplayName } from '@atlassian/mpac-types';
import React from 'react';
import { HostingParagraph } from "../HostingColumn.styles";

const contactVendorText = learnMoreUrl => /*#__PURE__*/React.createElement(React.Fragment, null, learnMoreUrl ? /*#__PURE__*/React.createElement("a", {
  href: learnMoreUrl,
  target: "_blank",
  rel: "noreferrer"
}, "Contact the vendor") : 'Contact the vendor', ' ', "to evaluate or purchase this app.");

const HostingLicenseGuidanceText = {
  CLOUD_PVA_TRY: /*#__PURE__*/React.createElement(HostingParagraph, null, "Paid subscription begins after your free trial."),
  CLOUD_PVA_BUY: /*#__PURE__*/React.createElement(HostingParagraph, null, "Cancel any time. Your paid subscription begins after 30 days."),

  CLOUD_FREE(compatibleProducts) {
    return /*#__PURE__*/React.createElement(HostingParagraph, null, "This app is free for ", compatibleProducts[0].name, " Cloud.");
  },

  CLOUD_FREE_PREINSTALLED(compatibleProducts) {
    return /*#__PURE__*/React.createElement(HostingParagraph, null, "This app is free and preinstalled on your", ' ', compatibleProducts.length === 1 ? "".concat(compatibleProducts[0].name, "  Cloud instance") : 'instance', ".");
  },

  CLOUD_PVV_PREINSTALLED(compatibleProducts, learnMoreUrl) {
    return /*#__PURE__*/React.createElement(HostingParagraph, null, "This app is preinstalled on your ", compatibleProducts[0].name, " Cloud instance.", ' ', contactVendorText(learnMoreUrl));
  },

  CLOUD_PVV(learnMoreUrl) {
    return /*#__PURE__*/React.createElement(HostingParagraph, null, contactVendorText(learnMoreUrl));
  },

  SERVER_DATACENTER_PVA_TRY: /*#__PURE__*/React.createElement(HostingParagraph, null, "Pay to continue after your trial ends, uninstall any time."),
  SERVER_PVA_BUY: /*#__PURE__*/React.createElement(HostingParagraph, null, "Licenses last forever, support and upgrades last for 12 months."),
  DATACENTER_PVA_BUY: /*#__PURE__*/React.createElement(HostingParagraph, null, "Your annual subscription includes licensing, support and software updates."),
  SERVER_DATACENTER_PVV: /*#__PURE__*/React.createElement(HostingParagraph, null, "This app is sold by a third-party vendor. Contact the vendor for a license."),

  SERVER_DATACENTER_FREE(compatibleProducts, isNotAnApp, hosting) {
    return /*#__PURE__*/React.createElement(HostingParagraph, null, "This app is free for", ' ', compatibleProducts.length === 1 ? "".concat(compatibleProducts[0].name, " ").concat(HostingDisplayName[hosting], " instances") : "Atlassian products on your ".concat(HostingDisplayName[hosting]), ".", !isNotAnApp && ' You may download and install it into your Atlassian application.');
  },

  MAYBE_DATACENTER_COMPATIBLE: /*#__PURE__*/React.createElement(HostingParagraph, null, "While Server apps are built for single-server deployments, many customers successfully install them in Data Center environments.")
};
export default HostingLicenseGuidanceText;